var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("SettingOrderSourceStrategyParcel.dialogForm.title"),
        visible: _vm.dialogVisible,
        width: "700px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "bj-label-colon",
          attrs: { model: _vm.form, rules: _vm.rules, inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.form.name } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "typeCondition" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("chooseText") },
                              model: {
                                value: _vm.form.typeCondition,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "typeCondition", $$v)
                                },
                                expression: "form.typeCondition",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "value" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              min: 1,
                              precision: 0,
                              controls: false,
                            },
                            model: {
                              value: _vm.form.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "value", $$v)
                              },
                              expression: "form.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "status" } },
                        [
                          _c("el-switch", {
                            staticClass: "switch",
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-alert", {
        attrs: {
          title: _vm.$t(
            "SettingOrderSourceStrategyParcel.dialogForm.condition"
          ),
          type: "warning",
          closable: false,
          "show-icon": "",
        },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }